import * as React from 'react'
import useDefaultValues from './useDefaultValues'

interface UseChannelsFiltersValuesOutput {
    setters: {
        chains: (newValue: number[]) => void;
    }
    values: {
        chains: number[];
    }
}

function useSelectedValues(): UseChannelsFiltersValuesOutput {
    const defaultFormValues = useDefaultValues()

    const [
        selectedChains,
        setSelectedChains,
    ] = React.useState<number[]>(defaultFormValues.chains)

    const settersRef = React.useRef({
        chains: setSelectedChains,
    })

    return React.useMemo(() => {
        return {
            setters: settersRef.current,
            values: {
                chains: selectedChains,
            },
        }
    }, [selectedChains])
}

export default useSelectedValues
